import { Link } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { RotateCcw, ChevronRight, LifeBuoy, Mail } from "lucide-react";

type Topic = {
  to: string;
  icon: React.ReactNode;
  title: string;
  description: string;
  tags: string[];
};

const TOPICS: Topic[] = [
  {
    to: "/help/refunds",
    icon: <RotateCcw size={22} />,
    title: "Rembourser un paiement",
    description:
      "Comment initier un remboursement total ou partiel, comprendre les statuts, le mode test, les rôles autorisés et les cas d'erreur les plus fréquents.",
    tags: ["Paiements", "Refund", "Finance"],
  },
];

export function HelpPage() {
  return (
    <div>
      <PageHeader
        title="Centre d'aide"
        breadcrumbs={[{ label: "Aide" }]}
      />

      <div className="card mb-6">
        <div className="card-body">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-brand-50 text-brand-700 flex items-center justify-center shrink-0">
              <LifeBuoy size={22} />
            </div>
            <div className="min-w-0">
              <div className="font-bold text-[#181c32] text-base mb-1">
                Guides d'utilisation du dashboard Moko Booking
              </div>
              <p className="text-sm text-[#3f4254] leading-relaxed">
                Retrouvez ici les procédures pas à pas pour les opérations courantes.
                Chaque guide reprend les prérequis, les rôles autorisés et les cas
                particuliers à connaître avant d'agir sur un paiement en production.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">
        {TOPICS.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            className="card hover:shadow-md transition-shadow group"
          >
            <div className="card-body">
              <div className="flex items-start gap-4 mb-3">
                <div className="w-12 h-12 rounded-xl bg-brand-50 text-brand-700 flex items-center justify-center shrink-0">
                  {t.icon}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <div className="font-bold text-[#181c32] text-base group-hover:text-brand-700 transition-colors">
                      {t.title}
                    </div>
                    <ChevronRight
                      size={16}
                      className="text-[#b5b5c3] group-hover:text-brand-700 group-hover:translate-x-0.5 transition-all"
                    />
                  </div>
                  <p className="text-sm text-[#3f4254] leading-relaxed">
                    {t.description}
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap gap-1.5 pl-16">
                {t.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 rounded bg-[#f5f8fa] text-[#7e8299]"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="card">
        <div className="card-body">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 rounded-xl bg-[#f5f8fa] text-[#3f4254] flex items-center justify-center shrink-0">
              <Mail size={20} />
            </div>
            <div className="min-w-0">
              <div className="font-bold text-[#181c32] text-sm mb-1">
                Besoin d'aide supplémentaire ?
              </div>
              <p className="text-sm text-[#3f4254] leading-relaxed">
                Si vous ne trouvez pas la réponse à votre question, écrivez à
                l'équipe Moko Afrika à{" "}
                <a
                  href="mailto:support@gofreshpay.com"
                  className="text-brand-700 hover:underline font-medium"
                >
                  support@gofreshpay.com
                </a>{" "}
                en précisant votre identifiant marchand et, si possible, la
                référence du paiement concerné.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
